<!-- 节庆热点 -->
<template>
  <div class="category-management">
    <page-title title="筛选">
      <el-row class="category-management__filter-header" :gutter="20">
        <el-col :xl="4" :span="6">
          <span>套餐名称：</span>
          <el-input v-model="filter.type" placeholder="请输入"></el-input>
        </el-col>
        <el-col :xl="4" :span="6">
          <span>买家信息：</span>
          <el-input v-model="filter.phone" placeholder="请输入"></el-input>
        </el-col>
        <el-col :xl="7" :span="9">
          <span>下单时间：</span>
          <el-date-picker
            v-model="filter.dateTime"
            type="datetimerange"
            range-separator="至"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-col>
        <el-col :xl="4" :span="6">
          <span>支付方式：</span>
          <el-select
            v-model="filter.payMode"
            placeholder="请输入"
            clearable
            filterable
          >
            <el-option
              v-for="item in payOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :xl="3" :span="6">
          <el-button @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-col>
      </el-row>
    </page-title>
    <page-title title="数据列表">
      <div class="category-management__body">
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%;"
          :header-cell-style="{ backgroundColor: `#f7f7f7` }"
          row-key="id"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          :default-expand-all="true"
        >
          <!-- <el-table-column type="index" label="序号" width="100"></el-table-column> -->
          <el-table-column
            prop="code"
            label="套餐订单号"
            width="200"
          ></el-table-column>
          <el-table-column prop="mealType" label="套餐类型">
            <template slot-scope="scope">
              <span>{{ mealType[scope.row.mealType] }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="授权类型"></el-table-column>
          <el-table-column prop="count" label="购买数量总量">
            <template slot-scope="scope">
              <span v-if="scope.row.count">{{ scope.row.count }}张</span>
            </template>
          </el-table-column>
          <el-table-column prop="allPrice" label="实付款">
            <template slot-scope="scope">
              <span v-if="scope.row.allPrice">￥{{ scope.row.allPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="consumeCount" label="已用" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.consumeCount }}张</span>
            </template>
          </el-table-column>
          <el-table-column prop="remainCount" label="剩余" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.remainCount }}张</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope" v-if="scope.row.code">
              <span v-if="scope.row.status == 0">正常</span>
              <span v-else-if="scope.row.status == 1">过期</span>
              <span v-else-if="scope.row.status == 2">失效</span>
              <span v-else>待付款</span>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="买家昵称"></el-table-column>
          <!-- <el-table-column prop="name" label="已用"></el-table-column>
                  <el-table-column prop="name" label="剩余"></el-table-column> -->
          <el-table-column
            prop="expirationDate"
            label="套餐有效期"
            width="200"
          ></el-table-column>
          <el-table-column
            width="200"
            prop="createTime"
            label="下单时间"
          ></el-table-column>
          <el-table-column prop="payMode" label="支付方式">
            <template slot-scope="scope">
              {{
                ["微信", "支付宝", "国版币", "线下支付", "待付款"][
                  scope.row.payMode
                ]
              }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <template v-if="scope.row.code">
                <el-button
                  class="edit"
                  type="text"
                  @click="handleDetail(scope.row.code)"
                  >详情</el-button
                >
                <el-button
                  class="edit"
                  type="text"
                  v-if="scope.row.status == 0 && scope.row.payMode == 3"
                  @click="handleInvalid(scope.row.code)"
                  >失效</el-button
                >
              </template>
            </template>
          </el-table-column>
        </el-table>
        <cus-pagination
          :total="total"
          :current-page.sync="currentPage"
          :page-size.sync="pageSize"
          @size-change="getList"
        ></cus-pagination>
      </div>
    </page-title>
  </div>
</template>

<script>
import { mealType } from "@/utils/enum";
import PageTitle from "@/components/pageTitle.vue";
import CusPagination from "@/components/cusPagination.vue";
import {
  getPicturePageList,
  festiveAdd,
  festiveEdit,
  festiveUpAndDown,
  festiveDel,
} from "@/api/page";
import { myMenuList } from "@/api/package";
import { Message } from "element-ui";
import { scope } from "@/config/config";
import { expire } from "@/api/menu";
export default {
  components: {
    PageTitle,
    CusPagination,
  },
  data() {
    return {
      mealType,
      apiEnd: false,
      loading: true,
      filter: {
        type: "",
        payMode: "",
        dateTime: [],
        phone: "",
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogMode: "add", // 默认模式
      currentData: {}, // 当前表单数据
      payOptions: [
        {
          value: 0,
          label: "微信",
        },
        {
          value: 1,
          label: "支付宝",
        },
        {
          value: 2,
          label: "国版币",
        },
        {
          value: 3,
          label: "线下支付",
        },
      ],
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        const { data } = await this.$ajax.get(myMenuList, {
          pageSize: this.pageSize,
          pageOn: this.currentPage,
          payMode: this.filter.payMode,
          phone: this.filter.phone,
          type: this.filter.type,
          beginTime: this.filter.dateTime ? this.filter.dateTime[0] : "",
          endTime: this.filter.dateTime ? this.filter.dateTime[1] : "",
        });

        // 处理数据,将相同订单号的记录组织成树形结构
        const resData = data?.data?.records ?? [];
        const orderMap = new Map();

        resData.forEach((item) => {
          if (!orderMap.has(item.code)) {
            // 为父节点添加唯一标识
            orderMap.set(item.code, {
              ...item,
              id: item.code, // 添加 id 作为唯一标识
              children: [],
            });
          } else {
            // 为子节点生成唯一标识
            const childItem = {
              ...item,
              id: `${item.code}_${orderMap.get(item.code).children.length}`, // 使用 code + 索引生成唯一 id
              code: "", // 子项不显示订单号
              type: item.type,
              count: item.count,
              allPrice: item.allPrice,
              consumeCount: item.consumeCount,
              remainCount: item.remainCount,
            };
            orderMap.get(item.code).children.push(childItem);
          }
        });

        this.tableData = Array.from(orderMap.values());
        this.total = data?.data?.total || 0;
      } catch (error) {
        console.error("获取列表失败:", error);
        this.$message.error("获取列表失败");
      } finally {
        this.loading = false;
      }
    },
    search() {
      this.getList();
    },
    reset() {
      this.filter.name = "";
      this.filter.type = "";
      this.filter.payMode = "";
      this.filter.dateTime = [];
      this.filter.phone = "";
      this.getList();
    },
    handleDetail(code) {
      this.$router.push({ path: "/packagePayDetail", query: { code } });
    },
    handleInvalid(code) {
      this.$confirm(
        "设置失效后，用户我的套餐将变为已失效状态，无法使用。",
        "失效",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          try {
            await this.$ajax.get(expire(code));
            this.$message.success("操作成功");
            this.getList(); // 刷新列表
          } catch (error) {
            console.error("失效操作失败:", error);
            this.$message.error("操作失败");
          }
        })
        .catch(() => {
          // 用户点击取消，不做任何操作
        });
    },
  },

  mounted() {
    this.getList();
    /*************  ✨ Codeium Command ⭐  *************/
    /**
     * Lifecycle hook called when the component is mounted.
     * It triggers the initial data fetch by calling getList.
     */
    /******  7082dec8-8c9a-4f67-9acc-5da39fca5a66  *******/
  },
};
</script>

<style lang="scss" scoped>
.category-management {
  .box-card {
    margin-bottom: 20px;
  }

  &__filter-header {
    display: flex;
    align-items: center;
  }

  &__body {
    .edit {
      color: #005bff;
    }

    .el-button.is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
    }

    .el-switch__label {
      color: #333333;
    }

    .el-table {
      border: 1px solid #ebeef5;
      border-bottom: none;
      margin-bottom: 20px;
    }
  }
}
</style>
